import React, { createContext, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

const LocationContext = createContext()

export const LocationProvider = ({ children }) => {
  const location = useLocation()
  const [prevLocation, setPrevLocation] = useState(null)

  useEffect(() => {
    setPrevLocation(location)
  }, [location])

  return <LocationContext.Provider value={{ location, prevLocation }}>{children}</LocationContext.Provider>
}

LocationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useLocationContext = () => useContext(LocationContext)
